<gstar-grid
  dataIdKey="residencyJurisdictionId"
  [source]="source.items"
  [totalCount]="source.total"
  [lazy]="true"
  [drawerSetting]="drawerSetting"
  [headers]="headers"
  [searchSetting]="searchSetting"
  [query]="query"
  (queryChange)="queryHandler($event)"
  [noDataFilteredMessage]="
    'admin.dashboard.notFoundRecordsMessage' | translate
  " />
